import { httpPost } from "utils/httpRequest"

const searchMembers = async ({
  pageNo,
  pageSize,
  searchName,
  searchEmail,
  isGuest,
  trialFlag,
  isActive,
  isBetaTester,
  hasCoach,
}) => {
  const payload = {
    pageNo,
    pageSize,
    searchName,
    searchEmail,
    isGuest,
    trialFlag,
    isActive,
  }
  if (isBetaTester !== null && isBetaTester !== undefined) {
    payload.isBetaTester = isBetaTester
  }
  if (hasCoach !== null && hasCoach !== undefined) {
    payload.hasCoach = hasCoach
  }
  const resp = await httpPost("admin/member/list", payload)
  return resp.data
}

const getMemberDetail = async (id) => {
  const resp = await httpPost("admin/member/queryDetail", {
    id,
  })
  return resp.data
}

const removeFreeTrial = async (id) => {
  const resp = await httpPost("admin/member/removeFreeTrial", {
    id,
  })
  return resp.data
}

const deactivateMember = async ({ id }) => {
  const resp = await httpPost("admin/member/deActive", {
    id,
  })
  return resp.data
}

const reactivateMember = async ({ id }) => {
  const resp = await httpPost("admin/member/reActive", {
    id,
  })
  return resp.data
}

const updateMemberEmail = async ({ memberId, newEmail }) => {
  const resp = await httpPost("admin/member/updateEmail", {
    memberId,
    newEmail,
  })
  return resp.data
}

const deleteMember = async ({ memberId }) => {
  const resp = await httpPost("admin/member/delete", {
    id: memberId,
  })
  return resp.data
}

const updateMemberPassword = async ({ memberId, newPassword }) => {
  const resp = await httpPost("admin/member/updatePassword", {
    memberId,
    newPassword,
  })
  return resp.data
}

const requestPasswordResetEmail = async ({ memberId }) => {
  const resp = await httpPost("admin/member/requestPasswordResetEmail", {
    id: memberId,
  })
  return resp.data
}

const cancelKeepSubscription = async ({ vipInfoId, memberId }) => {
  const resp = await httpPost("admin/member/cancelSubscription", {
    vipInfoId,
    memberId,
  })
  return resp.data
}

const reactivateKeepSubscription = async ({ vipInfoId, memberId }) => {
  const resp = await httpPost("admin/member/reactivateSubscription", {
    vipInfoId,
    memberId,
  })
  return resp.data
}

// New member access management endpoints
const getMemberAccess = async ({ memberId }) => {
  const resp = await httpPost("admin/member/getAccess", {
    memberId: parseInt(memberId),
  })
  return resp.data
}

const assignTier = async ({ memberId, programId, tierType, trialDays, isVerified }) => {
  const payload = { 
    memberId: parseInt(memberId)
  }
  
  if (programId) {
    payload.programId = parseInt(programId)
    // For program assignments, always include tierType as "product"
    payload.tierType = "product"
  } else if (tierType) {
    payload.tierType = tierType
  }
  
  if (trialDays && trialDays > 0) {
    payload.trialDays = parseInt(trialDays)
  }
  if (isVerified !== undefined) {
    payload.isVerified = Boolean(isVerified)
  }
  const resp = await httpPost("admin/member/assignTier", payload)
  return resp.data
}

const removeAccess = async ({ memberAccessId, memberId, tierType }) => {
  const payload = {}
  if (memberAccessId) {
    payload.memberAccessId = parseInt(memberAccessId)
  } else if (memberId && tierType) {
    payload.memberId = parseInt(memberId)
    payload.tierType = tierType
  }
  const resp = await httpPost("admin/member/removeAccess", payload)
  return resp.data
}

const assignProgram = async ({ memberId, programId }) => {
  const resp = await httpPost("admin/member/assignProgram", {
    memberId: parseInt(memberId),
    programId: parseInt(programId),
  })
  return resp.data
}

const updateMemberVerification = async ({ memberId, isVerified }) => {
  const resp = await httpPost("admin/member/updateVerification", {
    memberId: parseInt(memberId),
    isVerified: isVerified ? 1 : 0,
  })
  return resp.data
}

const updateMemberBetaTester = async ({ memberId, isBetaTester }) => {
  const resp = await httpPost("admin/member/updateBetaTester", {
    memberId: parseInt(memberId),
    isBetaTester: isBetaTester ? 1 : 0,
  })
  return resp.data
}

// Toggle the demo-account flag. When enabled, analytics rendered to this
// member are boosted on read for sales / investor demos.
const updateMemberDemoAccount = async ({ memberId, isDemoAccount }) => {
  const resp = await httpPost("admin/member/updateDemoAccount", {
    memberId: parseInt(memberId),
    isDemoAccount: isDemoAccount ? 1 : 0,
  })
  return resp.data
}

// Update community manager flag for a member (0/1)
const updateCommunityManager = async ({ memberId, isCommunityManager }) => {
  const resp = await httpPost("admin/member/edit", {
    id: memberId,
    isCommunityManager,
  })
  return resp.data
}

export {
  searchMembers,
  removeFreeTrial,
  deactivateMember,
  reactivateMember,
  getMemberDetail,
  updateMemberEmail,
  deleteMember,
  updateMemberPassword,
  requestPasswordResetEmail,
  cancelKeepSubscription,
  reactivateKeepSubscription,
  getMemberAccess,
  assignTier,
  removeAccess,
  assignProgram,
  updateMemberVerification,
  updateMemberBetaTester,
  updateMemberDemoAccount,
  updateCommunityManager,
}
